import { Injectable } from "@angular/core";
import { GameOverlayService } from "../../../services/game-overlay/game-overlay.service";
import { AudioService } from "../../../services/audio/audio.service";
import { DialogAction, DialogData, Phrase } from "../../../interfaces/common-interfaces";
import { GameStateService } from "../../../services/game-state/game-state.service";
import { GameState } from "../../../services/game-ui/game-state.enum";
import { GameUiService } from "../../../services/game-ui/game-ui.service";

@Injectable({ providedIn: 'root' })
export class NpsDetailService {
  constructor(
    private overlay: GameOverlayService,
    private audio: AudioService,
    private state: GameStateService,
    private ui: GameUiService,
  ) {}

  initDialog(data: DialogData): Phrase[] {
    this.audio.stopAll();
    this.overlay.restartOverlay();
    this.overlay.init({
      speaker: data.speaker,
      backgroundLayers: data.backgroundLayers,
      showBlackBackground: data.showBlackBackground,
      speakerLayers: data.speakerLayers,
      blackout: data.showBlackout,
      odwrotnie: data.odwrotnie,
      smooth: data.smooth,
      fonMusic: data.fonMusic,
      volume: data.volume
    });

    if (data.action) {
      return [];
    } else {
      if (data.fonMusic) {
        data.fonMusic.forEach(music => {
          this.audio.play(music, {loop: true, volume: data.volume});
        });
      }
      if (this.interactiveIsPossible(data.interactiveCondition)) {
        return data.phrases['start'];
      } else {
        return data.phrases['disabled'];
      }
    }
  }

  interactiveIsPossible(interactiveCondition?: string[]): boolean {
    return interactiveCondition ? interactiveCondition.every(el => this.state.getGameStatus('attractions')?.[el]) : true;
  }

  updatePhrase(data: DialogData, key: string, hint?: string, sound?: string, volume?: number): Phrase[] {
    if (data.showSpeakerInDialog) {
      this.overlay.showSpeaker();
    }
    if (hint && sound) {
      return [{ desc: hint, sound, volume, action: { type: 'none' } }];
    }
    return data.phrases[key] ?? [];
  }

  hideSpeaker() {
    this.overlay.hideSpeaker();
  }

  endDialog() {
    this.audio.stopAll();
  }
}
